import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const YinKlangNature = () => {
  useEffect(() => {
    document.title = "Yin & Klang in der Natur | Under Open Sky";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className="p-8 sticky top-0 bg-white/80 backdrop-blur-md z-10">
        <Link to="/" className="text-[10px] uppercase tracking-[0.2em] text-gray-400 hover:text-gray-800 transition-colors">
          ← Zurück zur Übersicht
        </Link>
      </nav>

      <article className="max-w-2xl mx-auto px-6 py-12 pb-40 font-light text-gray-600 leading-relaxed">
        <header className="mb-20">
          <h1 className="text-3xl font-light text-gray-800 mb-4 tracking-tight">Yin & Klang in der Natur</h1>
          <p className="text-gray-400 italic">Achtsamkeit im Freien</p>
        </header>
        
        <div className="space-y-10">
          <p>Dieses Angebot verbindet eine sanfte, meditative Körperpraxis mit der Resonanz von Therapie-Klangschalen. Wir praktizieren an wechselnden Orten – im Wald, auf Wiesen oder in offenen Landschaften.</p>
          
          <p>Dabei ist die Natur keine bloße Kulisse. Sie ist ein aktiver Teil der Erfahrung. Das Rauschen der Blätter, die Weite des Himmels und die Beschaffenheit des Bodens fließen direkt in die Wahrnehmung ein.</p>
          
          <p>Unser Verstand ist oft wie ein „Monkey Mind“ – rastlos, springend von einem Gedanken zum nächsten. Die achtsamen Übungen helfen dabei, diesen Verstand zu beruhigen und eine innere Stille entstehen zu lassen.</p>
          
          <p>Der Klang der Schalen dient hierbei als zusätzlicher Anker. Er unterstützt dabei, die Aufmerksamkeit immer wieder sanft zurück ins Hier und Jetzt zu führen, wenn Gedanken wieder dominanter werden.</p>
          
          <p className="pt-8 border-t border-gray-50 italic">
            Es geht um Entschleunigung, Wahrnehmung und reines Dasein. Ohne Heilsversprechen, ohne Esoterik – einfach nur Präsenz unter freiem Himmel.
          </p>
        </div>
      </article>
    </div>
  );
};

export default YinKlangNature;